import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Divider } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const AsyncSelectMetaStyle = styled.div`
  padding: 4px 8px;
  padding-top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  color: ${props => props.theme.colorTextSecondary};

  &--icon {
    flex: 0 0 auto;
    font-size: 16px;
    padding-left: 4px;
    padding-right: 16px;
  }

  &--text {
    flex: 1 1 auto;
  }
`;

const AsyncSelectMetaDivider = styled(Divider)`
  margin: 4px 0;
`;

export interface AsyncSelectMeta {
  shown: number;
  total: number;
}

export interface IAsyncSelectInputMetaProps {
  meta?: AsyncSelectMeta;
}

/**
 * Dati aggiuntivi per la select asincrona
 */
export function AsyncSelectInputMeta(props: IAsyncSelectInputMetaProps) {
  const { meta } = props;
  const { t } = useTranslation();

  if (!meta) return null;
  const { shown, total } = meta;

  return (
    <>
      <AsyncSelectMetaDivider />
      <AsyncSelectMetaStyle>
        <div className="async-select-input-meta--icon">
          <InfoCircleOutlined />
        </div>
        <div className="async-select-input-meta--text">
          {t(
            'inputs.async-select-input-meta.content',
            'Mostrati {{shown}} di {{total}}.',
            { shown, total },
          )}
          {meta.shown < meta.total &&
            t(
              'inputs.async-select-input-meta.filter',
              'Filtrare la ricerca digitando per migliorare i risultati.',
            )}
        </div>
      </AsyncSelectMetaStyle>
    </>
  );
}
